import { CalendarCloudSettingType } from '../store/schema/CalendarCloudSettingType';
import { getStore } from '../store/store';

/**
 * Gets the value for the ShouldEventsEndEarly cloud setting
 */
export default function getShouldEventsEndEarlyCloudSetting(): boolean | undefined {
    const shouldEventsEndEarlySetting = getStore().settings.get(
        CalendarCloudSettingType.ShouldEventsEndEarly.toLowerCase()
    );

    return shouldEventsEndEarlySetting != null ? !!shouldEventsEndEarlySetting.value : undefined;
}
